import { render, staticRenderFns } from "./InventarioArmas.vue?vue&type=template&id=76618dc0"
import script from "./InventarioArmas.vue?vue&type=script&lang=js"
export * from "./InventarioArmas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports